module.exports = __webpack_public_path__ + "static/media/freelancer-highlight-5.06334026.webp";